/* ==========================================================================
   ROMANTICO - Transparent header controller
   Sets --header-height (so the hero can tuck under the header) and toggles an
   .is-solid class once the page is scrolled past a small threshold, with a
   passive scroll listener. Runs only when a transparent header is present.
   classList.toggle is a no-op for styling when the value is unchanged, so the
   direct toggle on scroll stays cheap.
   ========================================================================== */
(function () {
  var wrapper = document.querySelector('.header-wrapper--transparent');
  if (!wrapper) return;

  var sectionHeader = wrapper.closest('.section-header') || wrapper;

  function setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', sectionHeader.offsetHeight + 'px');
  }
  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(setHeaderHeight);
  }

  var threshold = 60;
  function update() {
    var scrolled = (window.pageYOffset || document.documentElement.scrollTop) > threshold;
    wrapper.classList.toggle('is-solid', scrolled);
  }

  window.addEventListener('scroll', update, { passive: true });
  update();
})();
